// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__1m8yt","image":"Login_image___axIP","content":"Login_content__1hMjs","form":"Login_form__iSpE_","submit":"Login_submit__2koOF"};